import { render } from "./ColorBackground.vue?vue&type=template&id=d4d15b22&lang=pug"
import script from "./ColorBackground.vue?vue&type=script&lang=js"
export * from "./ColorBackground.vue?vue&type=script&lang=js"

import "./ColorBackground.vue?vue&type=style&index=0&id=d4d15b22&lang=scss"

import exportComponent from "/Applications/DEV/kevin/GIT/monafoto.ee/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__